import React, { Component } from 'react';
import { connect } from 'react-redux';
import { _LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import { recommendProductActions } from '../../../store/modules/recommend/product';
import {
  RECOMMEND_PRODUCT_LIST_SEARCH_DATA_MODEL,
  RECOMMEND_PRODUCT_LIST_SEARCH_OPTION_MODEL,
} from '../../../store/modules/recommend/product/models';
import RecommendProductListWrap from '../../../views/recommend/product/list/RecommendProductListWrap';

class RecommendProductListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    const { setData } = this.props;

    this.getList({
      /**
       *  검색 옵션
       */
      searchOption: RECOMMEND_PRODUCT_LIST_SEARCH_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });

    /**
     * 검색 박스 초기화
     */
    setData({
      path: ['recommendProductList', 'searchData'],
      value: RECOMMEND_PRODUCT_LIST_SEARCH_DATA_MODEL,
    });
  };

  /**
   * 리스트 불러오기
   */
  getList = async (data) => {
    const { getRecommendProductList, recommendProductList } = this.props;
    const { searchOption, sortOption, pagination } = recommendProductList;

    getRecommendProductList({
      searchOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  render() {
    const { recommendProductList, setData } = this.props;

    return (
      <RecommendProductListWrap recommendProductList={recommendProductList} setData={setData} getList={this.getList} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    recommendProductList: state.recommendProduct.recommendProductList,
  };
};

const mapDispatchToProps = {
  setData: recommendProductActions.setData,
  getRecommendProductList: recommendProductActions.getRecommendProductList,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecommendProductListContainer);
